import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

class BottomFooter extends Component {
  render() {
    return (
      <Grid container style={{marginBottom: "20px"}}>

      </Grid>
    );
  }
}

export default BottomFooter;